// Human-readable "trading week" label (Mon-Fri) that this weekly thesis
// applies to, derived from when it was generated - not a raw ISO week code.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const fmtDay = (d) => `${String(d.getUTCDate()).padStart(2, "0")} ${MONTHS[d.getUTCMonth()]}`;

export function tradingWeekLabel(generatedAtIso) {
  if (!generatedAtIso) return "";
  const gen = new Date(generatedAtIso);
  const day = gen.getUTCDay(); // 0=Sun..6=Sat
  const monday = new Date(gen);
  if (day === 0) monday.setUTCDate(gen.getUTCDate() + 1); // Sunday -> next Monday
  else if (day === 6) monday.setUTCDate(gen.getUTCDate() + 2); // Saturday -> next Monday
  else monday.setUTCDate(gen.getUTCDate() - (day - 1)); // Tue-Fri -> back to this Monday
  const friday = new Date(monday);
  friday.setUTCDate(monday.getUTCDate() + 4);
  return `Week of ${fmtDay(monday)} \u2013 ${fmtDay(friday)}`;
}
